module.exports = (__parcel__import__("./" + "Doppio.4a9f3a68.js")).then(() => parcelRequire('jTOzh'));